
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"6","height":"12","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M5.984.742v1.453h-.96c-.277-.76-.766-1.14-1.47-1.14-.52 0-.955.244-1.304.734-.349.49-.523 1.167-.523 2.031 0 .766.143 1.362.43 1.79.286.426.89.794 1.812 1.1.61.214 1.044.438 1.304.673.26.229.391.562.391 1 0 .515-.193 1.008-.578 1.476-.38.47-.945.97-1.695 1.5l-.461-.554c.958-.709 1.437-1.39 1.437-2.047 0-.287-.078-.503-.234-.649-.156-.145-.414-.283-.774-.414-1.145-.406-1.94-.89-2.382-1.453C.539 5.674.32 4.93.32 4.008c0-1.057.326-1.922.977-2.594C1.947.737 2.813.398 3.89.398c.724 0 1.421.115 2.093.344z","fill":"currentColor"}})])
          )
        }
      }
    